@file:OptIn(InternalResourceApi::class)

package thedailycardioadmin.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/thedailycardioadmin.shared.generated.resources/"

internal val Res.font.noto_color_emoji_regular: FontResource by lazy {
      FontResource("font:noto_color_emoji_regular", setOf(
        ResourceItem(setOf(), "${MD}font/noto_color_emoji_regular.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("noto_color_emoji_regular", Res.font.noto_color_emoji_regular)
}
